function initflickitySlider2() {
    // Use data-flickity attribute to manually initiate flickity
    console.log("Init manual reviews");
    let plug_flickity = document.querySelectorAll('[plug-flickity-2]')
    plug_flickity.forEach(function(elem) {
        console.log(elem)
        console.log(elem.classList)
        if (!Array.from(elem.classList).includes('flickity-enabled')) {
            let slider = elem;
            let slide = '[plug-flickity-slide]';
            let prevArrow = slider.querySelector('[plug-flickity-prevArrow]');
            let nextArrow = slider.querySelector('[plug-flickity-nextArrow]');
            let dot_attribute = 'plug-flickity-dot';
            let dot_attribute_mobile = 'plug-flickity-dot-mobile';
            let slide_count = Object.is(slider.getAttribute('slide_count'), undefined) ? 1 : parseInt(elem.getAttribute('slide_count'));
            let infinite = Object.is(Array.from(slider.classList).includes('flickity-infinite'), true) ? true : false;
            let fade = Object.is(Array.from(slider.classList).includes('flickity-fade'), true) ? true : false;
            let autoPlay = Object.is(Array.from(slider.classList).includes('flickity-autoplay'), true) ? true : false;
            let dot = Object.is(Array.from(slider.classList).includes('flickity-dot'), "true") ? true : false;
            let mobile_dot = Object.is(Array.from(slider.classList).includes('flickity-mobile_dot'), true) ? true : false;
            let adaptive = Object.is(Array.from(slider.classList).includes('flickity-adaptive'), true) ? true : false;
            let enable_arrows = Object.is(Array.from(slider.classList).includes('flickity-arrows'), true) ? true : false;
            let center =  Object.is(Array.from(slider.classList).includes('flickity-center'), true) ? 'center' : 'left'; // if value is equals to "true" return true otherwise false
            let watchCSS =  Object.is(Array.from(slider.classList).includes('watch-css'), true) ? true : false;

            var flkty = new Flickity(slider,{
                wrapAround: infinite,
                fade: fade,
                prevNextButtons: enable_arrows,
                pageDots: dot,
                adaptiveHeight: adaptive,
                cellSelector: slide,
                autoPlay: autoPlay,
                cellAlign: center,
                watchCSS: watchCSS
            })

            if (prevArrow.length > 0) {
                prevArrow.on('click', function() {
                    prevSlide(slider);
                })
            }
            if (nextArrow.length > 0) {
                nextArrow.on('click', function() {
                    nextSlide(slider);
                })
            }
            if (window.innerWidth > 749) {
                flkty.pausePlayer()
            }
            window.addEventListener('resize', function() {
                if (window.innerWidth > 749) {
                    flkty.pausePlayer()
                } else {
                    flkty.unpausePlayer()
                }
            })
        }
    });
    function nextSlide(slider) {
        slider.flickity( 'next', true );
        flkty.next(true)
    }   
    function prevSlide(slider) {
        flkty.previous(true)
    }
}

document.addEventListener('DOMContentLoaded', function() {
    initflickitySlider2();
})


if (Shopify.designMode) {
function reinitSlider (event) {
    let selected_section = false;
    if (event.target.hasAttribute('plugflickity') || event.target.closest('[plugflickity]') != undefined || event.target.hasAttribute('plug-pagination')) {
    selected_section = true;
    }
    if(selected_section) {
    initflickitySlider();
    }
}
document.addEventListener('shopify:block:select', reinitSlider);
document.addEventListener('shopify:section:unload', function(e) {
    document.removeEventListener('shopify:block:select', reinitSlider);
    document.addEventListener('shopify:block:select', reinitSlider);
});
} 


